import React, { useState } from "react";
import { PageContentLayout, PageHeaderLayout } from "../../../shared/layout";
import { AreaChartOutlined } from "@ant-design/icons";
import { mainTitleIcon } from "../../../shared/globalStyling/style";
import { withRouter } from "react-router-dom";
import ExportButtons from "./components/ExportButtons";
import ChannelTabs from "./components/ChannelTabs";

const SeoDetailsView = ({
  name = "",
  exportData = false,
  isMultiChannel = false,
  googleReportKey = "",
  commerceKey = "",
  hasGoogle = false,
  hasCommerce = false,
  location,
  domain,
}) => {
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab");

  //Title shown on browser tab
  document.title = `${name} SEO Details View`;

  const [reportData, setReportData] = useState([]);

  return (
    <React.Fragment>
      <PageHeaderLayout
        title={name}
        titleIcon={<AreaChartOutlined style={mainTitleIcon} />}
        rightContent={
          <ExportButtons
            exportData={exportData}
            name={name}
            currentTab={currentTab}
            reportData={reportData}
          />
        }
      />
      <PageContentLayout>
        <ChannelTabs
          isMultiChannel={isMultiChannel}
          googleReportKey={googleReportKey}
          commerceKey={commerceKey}
          hasGoogle={hasGoogle}
          hasCommerce={hasCommerce}
          setReportData={setReportData}
          domain={domain}
        />
      </PageContentLayout>
    </React.Fragment>
  );
};

export default withRouter(SeoDetailsView);
